const STATIC_ROLE_LOCKS = {};

const emptyLocks = { lockedBrand: '', lockedChannel: '' };

const readStoredUserData = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const raw = window.localStorage.getItem('user_data');
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
};

const extractLocks = (source = '') => {
  if (!source || typeof source === 'string') {
    return emptyLocks;
  }

  const roleMetadata = source.role_metadata && typeof source.role_metadata === 'object'
    ? source.role_metadata
    : {};
  const lockedFilters = roleMetadata.locked_filters && typeof roleMetadata.locked_filters === 'object'
    ? roleMetadata.locked_filters
    : {};

  const lockedBrand = source.lockedBrand
    || source.locked_brand
    || lockedFilters.brand
    || lockedFilters.locked_brand
    || '';
  const lockedChannel = source.lockedChannel
    || source.locked_channel
    || lockedFilters.channel
    || lockedFilters.locked_channel
    || '';

  return {
    lockedBrand: lockedBrand ? String(lockedBrand).trim() : '',
    lockedChannel: lockedChannel ? String(lockedChannel).trim() : '',
  };
};

export const getRoleLocks = (source = '') => {
  const roleKey = (source && typeof source === 'object')
    ? (source.role || source.role_name || '')
    : String(source || '');

  if (roleKey.toLowerCase() === 'executive') {
    return emptyLocks;
  }

  const storedUser = readStoredUserData();
  const storedRole = storedUser?.role || storedUser?.role_name || '';
  if (storedRole.toLowerCase() === 'executive') {
    return emptyLocks;
  }

  if (source && typeof source === 'object') {
    const locks = extractLocks(source);
    if (locks.lockedBrand || locks.lockedChannel) {
      return locks;
    }
    const rKey = source.role || source.role_name || '';
    return STATIC_ROLE_LOCKS[rKey] || emptyLocks;
  }

  if (storedUser && storedRole === source) {
    const locks = extractLocks(storedUser);
    if (locks.lockedBrand || locks.lockedChannel) {
      return locks;
    }
  }

  return STATIC_ROLE_LOCKS[source] || emptyLocks;
};

export const applyRoleLocks = (params = {}, source = '') => {
  const { lockedBrand, lockedChannel } = getRoleLocks(source);
  const next = { ...params };

  if (lockedBrand && next.brand !== lockedBrand) {
    next.brand = lockedBrand;
    next.sku_id = '';
  }

  if (lockedChannel && next.channel !== lockedChannel) {
    next.channel = lockedChannel;
  }

  return next;
};

export const normalizeRoleUser = (user) => {
  if (!user) return user;

  const role = user.role || user.role_name || '';
  if (role.toLowerCase() === 'executive') {
    return {
      ...user,
      role,
      role_metadata: {
        ...(user.role_metadata || {}),
        locked_filters: {},
      },
      lockedBrand: '',
      lockedChannel: '',
    };
  }

  const locks = extractLocks(user);
  const effectiveLocks = (locks.lockedBrand || locks.lockedChannel)
    ? locks
    : (STATIC_ROLE_LOCKS[role] || emptyLocks);
  const roleMetadata = user.role_metadata && typeof user.role_metadata === 'object'
    ? user.role_metadata
    : {};
  const mergedLockedFilters = {
    ...(roleMetadata.locked_filters || {}),
    ...(user.locked_filters || {}),
  };

  if (effectiveLocks.lockedBrand) {
    mergedLockedFilters.brand = effectiveLocks.lockedBrand;
  }
  if (effectiveLocks.lockedChannel) {
    mergedLockedFilters.channel = effectiveLocks.lockedChannel;
  }

  return {
    ...user,
    role,
    role_metadata: {
      ...roleMetadata,
      locked_filters: mergedLockedFilters,
    },
    lockedBrand: effectiveLocks.lockedBrand,
    lockedChannel: effectiveLocks.lockedChannel,
  };
};
